import * as React from "react";
import GoogleMapsProvider from "@route-planner/components/GoogleMapsProvider";
import RoutePlanner from "@route-planner/components/RoutePlanner";

const Component = (props) => {
  return (
    <GoogleMapsProvider apiKey={process.env.REACT_APP_GOOGLE_KEY}>
      <RoutePlanner initialView="login" />
    </GoogleMapsProvider>
  );
};

const page = {
  routeProps: {
    path: "AlertsLogin",
    component: Component,
  },
  name: "Alerts Account",
  label: "Alerts Account",
  title: "Alerts Account",
  showOnMenu: false,
};

export default page;
